<div class="chart-wrapper" *ngIf="hasData">
    <canvas class="desktop-chart" height="80%" width="100%" baseChart [datasets]="chartData"  #chart [labels]="chartLabels" 
        [options]="chartOptions" [legend]="false" [type]="'doughnut'">
    </canvas>

</div>